import React, { useState, useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { Dropdown } from 'primereact/dropdown';
import { useDispatch, useSelector } from "react-redux";
import styles from "./CollabsView.module.css";
import Langs, { Localize } from "../../app/lang/langs";
import exportIcon from "../../assets/images/export.png";
import exportIconFocus from "../../assets/images/exportFocus.png";
import ImageButton from "../../components/buttons/ImageButton";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
  checkPermission,
  getTagClass
} from "../../app/utils/helpers";
import moment from "moment";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Tag } from "primereact/tag";
import CollabModalDetails from "./CollabModalDetails";
import { showSuccessToast, showErrorToast } from "../../app/utils/helpers";
import { config } from "../../app/utils/config";
import { useNavigate, useParams } from "react-router-dom";
import {
  setCollabModalData,
  setUpdatePermissionsRes,
  setSelectedView,
  getAllContracts,
  getAllCollabs,
  getAllMissionReviews
} from "../../components/collabs/collabsSlice";
import { Calendar } from "primereact/calendar";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import ExcelManager from "../../app/managers/excelManager";
import { ViewSelectButton } from "../../components/buttons/ViewSelectButton";
import { getAllMissions } from "../../components/teams/teamsSlice";
import WeeklyFollowupModal from "./WeeklyFollowupModal";

export function ContractsView() {

  const dispatch = useDispatch()
  const urlParams = useParams()
  const navigate = useNavigate()
  const mounted = useRef(null)
  const dtCollabs = useRef(null)
  const dtMissions = useRef(null)
  const dtMissionsSuivis = useRef(null)

  const selectedTeamsIds = useSelector((state) => state.teams.selectedTeamsIds)
  const permissionsMessage = useSelector((state) => state.collabs.updatePermissionsRes)
  const allCollabsList = useSelector((state) => state.collabs.allCollabsList)
  const allMissionsList = useSelector((state) => state.teams.allMissions)
  const allMissionsFollowups = useSelector((state) => state.collabs.allMissionsFollowups)
  const permissions = useSelector((state) => state.login.permissions)
  const isMobile = useSelector((state) => state.settings.isMobile)
  const allContractsList = useSelector((state) => state.collabs.allContracts)
  const selectedView = useSelector((state) => state.collabs.selectedView)
  const [collabsGlobalFilterValue, setCollabsGlobalFilterValue] = useState('')
  const [missionsGlobalFilterValue, setMissionsGlobalFilterValue] = useState('')
  const [missionsSuivisGlobalFilterValue, setMissionsSuivisGlobalFilterValue] = useState('')
  const [selectedFollowup, setSelectedFollowup] = useState()
  const [filteredContracts, setFilteredContracts] = useState(null)
  const [filteredMissions, setFilteredMissions] = useState(null)
  const [filteredMissionsSuivis, setFilteredMissionsSuivis] = useState(null)

  const [collabsFilters, setCollabsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    matricule: { value: null, matchMode: FilterMatchMode.CONTAINS },
    current_poste: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nature_emploi: { value: null, matchMode: FilterMatchMode.CONTAINS },
    etablissement: { value: null, matchMode: FilterMatchMode.CONTAINS },
    current_team_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type_collab: { value: null, matchMode: FilterMatchMode.EQUALS },
    motif_sortie: { value: null, matchMode: FilterMatchMode.IN },
    statut: { value: null, matchMode: FilterMatchMode.EQUALS },
    company: { value: null, matchMode: FilterMatchMode.EQUALS },
    periodeEssai1: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    periodeEssai2: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    exitDate: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    type_contrat: { value: null, matchMode: FilterMatchMode.IN },
    new_date_fin_cp: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    date_debut_cp: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    date_fin_cp: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] }
  })

  const [missionsFilters, setMissionsFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    statut: { value: null, matchMode: FilterMatchMode.EQUALS },
    start_date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
    end_date: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] }
  })

  const [missionsSuivisFilters, setMissionsSuivisFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    prenom: { value: null, matchMode: FilterMatchMode.CONTAINS },
    type: { value: null, matchMode: FilterMatchMode.EQUALS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
    client: { value: null, matchMode: FilterMatchMode.EQUALS },
    current_team_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
  })

  const [viewsOptions] = useState([
    { label: <Langs str='Contracts' />, value: 0 },
    { label: <Langs str='Missions' />, value: 1 },
    { label: <Langs str='Suivis Missions' />, value: 2 }
  ])

  useEffect(() => {
    if (checkPermission(config.scopes.collabs, config.permissionTypes.view)) {
      dispatch(setSelectedView(0))
    }
  }, [mounted, permissions])

  useEffect(() => {
    if (urlParams.subView && viewsOptions[urlParams.subView]) {
      dispatch(setSelectedView(urlParams.subView))
    }
  }, [urlParams])

  useEffect(() => {
    if (!mounted.current) {
      if (checkPermission(config.scopes.collabs, config.permissionTypes.view)) {
        dispatch(getAllCollabs())
        dispatch(getAllContracts())
        dispatch(getAllMissions())
        dispatch(getAllMissionReviews())
      }
      mounted.current = true
    }
  }, [dispatch])

  useEffect(() => {
    toastRes()
  }, [permissionsMessage])

  const onCollabsGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...collabsFilters };

    _filters['global'].value = value;

    setCollabsFilters(_filters);
    setCollabsGlobalFilterValue(value);
  }

  const onMissionsGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...missionsFilters };

    _filters['global'].value = value;

    setMissionsFilters(_filters);
    setMissionsGlobalFilterValue(value);
  }

  const onMissionsSuivisGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...missionsSuivisFilters };

    _filters['global'].value = value;

    setMissionsSuivisFilters(_filters);
    setMissionsSuivisGlobalFilterValue(value);
  }

  const collabsTableHeader = () => {
    return (<Row>
      <Col md={6}>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText value={collabsGlobalFilterValue} onChange={onCollabsGlobalFilterChange} placeholder="Keyword Search" />
        </IconField>
      </Col>
    </Row>
    )
  }

  const missionsTableHeader = () => {
    return (<Row>
      <Col md={6}>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText value={missionsGlobalFilterValue} onChange={onMissionsGlobalFilterChange} placeholder="Keyword Search" />
        </IconField>
      </Col>
    </Row>
    )
  }

  const missionsSuivisTableHeader = () => {
    return (<Row>
      <Col md={6}>
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search" />
          <InputText value={missionsSuivisGlobalFilterValue} onChange={onMissionsSuivisGlobalFilterChange} placeholder="Keyword Search" />
        </IconField>
      </Col>
    </Row>
    )
  }

  const exportExcelContracts = () => {
    let filteredData = filteredContracts || allContractsList
    let exportDataContract = filteredData.reduce((array, current) => {
      let contractData = {
        "Prénom": current.prenom || "",
        "Nom de famille": current.nom || "",
        "ID": current.id || "",
        "ID Collaborateur": current.id_collab || "",
        "ID Entreprise": current.id_company || "",
        "ID Sous-traitant": current.id_subcontractor || "",
        "Type de contrat": current.type_contrat || "",
        "Type de collaborateur": current.type_collab || "",
        "Statut emploi": current.statut_emploi || "",
        "Date d'entrée": current.entree_date ? moment(current.entree_date).format("DD-MM-YYYY") : "",
        "Date de sortie": current.sortie_date ? moment(current.sortie_date).format("DD-MM-YYYY") : "",
        "Poste": current.position || "",
        "Coefficient": current.coefficient || "",
        "Code CSP": current.code_csp || "",
        "Période d’essai 1": current.periode_essai_1 ? moment(current.periode_essai_1).format("DD-MM-YYYY") : "",
        "Période d’essai 2": current.periode_essai_2 ? moment(current.periode_essai_2).format("DD-MM-YYYY") : "",
        "Mise sous pli": current.mise_sous_pli || "",
        "Dédit formation": current.dedit_formation || "",
        "Motif de sortie": current.motif_sortie || "",
        "Durée période d’essai 1": current.duree_periode_essai_1 || "",
        "Durée période d’essai 2": current.duree_periode_essai_2 || "",
        "Date rappel 1": current.date_rappel_1 ? moment(current.date_rappel_1).format("DD-MM-YYYY") : "",
        "Date rappel 2": current.date_rappel_2 ? moment(current.date_rappel_2).format("DD-MM-YYYY") : "",
        "N’a pas démarré": current.did_not_start || "",
        "TJM achat": current.tjm_achat || "",
        "TJM vente": current.tjm_vente || "",
        "Date début CP": current.date_debut_cp ? moment(current.date_debut_cp).format("DD-MM-YYYY") : "",
        "Date fin CP": current.date_fin_cp ? moment(current.date_fin_cp).format("DD-MM-YYYY") : "",
        "Nouvelle date début CP": current.new_date_debut_cp ? moment(current.new_date_debut_cp).format("DD-MM-YYYY") : "",
        "Nouvelle date fin CP": current.new_date_fin_cp ? moment(current.new_date_fin_cp).format("DD-MM-YYYY") : "",
        "Date d’envoi": current.sent_date ? moment(current.sent_date).format("DD-MM-YYYY") : "",
        "Mutuelle": current.mutuelle || "",
        "Ticket restaurant": current.ticket_restaurant || "",
        "Pass Navigo": current.pass_navigo || "",
        "Taux horaire": current.taux_horaire || "",
        "Établissement": current.etablissement || "",
        "Nature emploi": current.nature_emploi || "",
        "Renouvellement période d’essai": current.renew_periode_essai || "",
        "Responsable contractuel": current.responsable_contractuel || "",
        "Statut Silae": current.silae_status || "",
        "Date de création": current.created_at ? moment(current.created_at).format("DD-MM-YYYY") : "",
        "Date de mise à jour": current.updated_at ? moment(current.updated_at).format("DD-MM-YYYY") : "",
        "Créé par": current.created_by || "",
        "Mis à jour par": current.updated_by || "",
        "Nom sous-traitant": current.subcontractor_name || "",
        "Tuteur": current.tutor_name || "",
        "Ecole": current.school || "",
        "Contact école": current.school_contact || "",
        "Diplome": current.diploma || "",
        "Coût de la formation": current.training_cost || "",
        "Reste à charge": current.remaining_cost || "",
        "Commentaires": current.comments || "",
      }

      array.push(contractData)
      return array
    }, [])
    ExcelManager.getInstance().generateAndDownloadExcelFromData(exportDataContract, "contrats_collaborateurs")
  }

  const exportExcelMissions = () => {
    let filteredData = filteredMissions || allMissionsList
    let exportDataMissions = filteredData.reduce((array, current) => {
      let missionData = {
        "Prénom": current.prenom || "",
        "Nom de famille": current.nom || "",
        "Equipe": current.current_team_name || "",
        "Localization": current.current_team_location || "",
        "Poste": current.poste_name || "",
        "Groupe": current.group_name || "",
        "Date début": current.start_date ? moment(current.start_date).format("DD-MM-YYYY") : "",
        "Date fin": current.end_date ? moment(current.end_date).format("DD-MM-YYYY") : "",
        "Créé": current.created_at ? moment(current.created_at).format("DD-MM-YYYY") : "",
        "Créé par": current.created_by || "",
        "MAJ": current.updated_at ? moment(current.updated_at).format("DD-MM-YYYY") : "",
        "MAJ par": current.updated_by || "",
      }

      array.push(missionData)
      return array
    }, [])
    ExcelManager.getInstance().generateAndDownloadExcelFromData(exportDataMissions, "missions_collaborateurs");
  }

  const exportExcelSuivisMissions = () => {
    let filteredData = filteredMissionsSuivis || allMissionsFollowups
    let exportDataSuivisMissions = filteredData.reduce((array, current) => {
      let suivisMissionData = {
        "Prénom": current.prenom || "",
        "Nom de famille": current.nom || "",
        "Semaine": current.week || "",
        "Statut": Localize(current.status) || "",
        "Suivi": Localize(current.type) || "",
        "Client": current.client || "",
        "Equipe": current.current_team_name || "",
        "Commentaires": current.comments || "",
        "Managers": current.managers || "",
        "Créé": current.created_at ? moment(current.created_at).format("DD-MM-YYYY") : "",
        "Créé par": current.createdBy || "",
        "MAJ": current.updated_at ? moment(current.updated_at).format("DD-MM-YYYY") : "",
        "MAJ par": current.updatedBy || "",
      }

      array.push(suivisMissionData)
      return array
    }, [])
    ExcelManager.getInstance().generateAndDownloadExcelFromData(exportDataSuivisMissions, "suivis_missions_collaborateurs");
  }

  const statusBodyTemplate = (rowData) => {
    if (rowData.is_new) {
      return <Tag value={<Langs str="New" />} severity={getTagClass("New")} />
    }
    return <div style={{ color: (["Présent", "Actif"].includes(rowData.statut) ? "green" : "red") }}>
      <strong>{rowData.statut}</strong>
    </div>
  }

  const statusFollowupBodyTemplate = (rowData) => {
    return <Tag value={<Langs str={rowData.status} />} severity={getTagClass(rowData.status)} />

  }

  const typeFollowupBodyTemplate = (rowData) => {
    return <Tag value={<Langs str={rowData.type} />} severity={getTagClass(rowData.type)} />
  }

  const formatDate = (value) => {
    if (value) {
      value = new Date(value)
      return value.toLocaleDateString({
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    }
    else return null
  }

  const dateBodyTemplate = (rowData, column) => {
    if (rowData[column.field]) {
      return <label>
        {formatDate(rowData[column.field])}
      </label>
    }
  }

  const startDateBodyTemplate = (rowData, column) => {
    if (rowData[column.field]) {
      let color = "black"
      if (moment(rowData[column.field]).isAfter(moment())) {
        color = "green"
      }
      return <strong style={{ color }}>
        {formatDate(rowData[column.field])}
      </strong>
    }
  }

  const endDateBodyTemplate = (rowData, column) => {
    if (rowData[column.field]) {
      let color = "black"
      if (moment(rowData[column.field]).isBefore(moment())) {
        color = "red"
      }
      return <strong style={{ color }}>
        {formatDate(rowData[column.field])}
      </strong>
    }
  }

  function toastRes() {
    if (permissionsMessage != null) {
      if (permissionsMessage.trim().toLowerCase().includes("successfully")) {
        showSuccessToast(permissionsMessage)
      } else {
        showErrorToast(permissionsMessage)
      }
      dispatch(setUpdatePermissionsRes())
    }
  }

  function viewCollabModal(data) {
    if (!checkPermission(config.scopes.collabs, config.permissionTypes.edit)) return;
    const modalData = { ...data, show: true, tabIndex: selectedView == 1 ? 0 : 1 }
    dispatch(setCollabModalData(modalData))
  }

  function viewReviewModal(data) {
    setSelectedFollowup(data)
  }

  let companies = [], statuses = [], collabsTypes = [], silaeStatuses = [], followupTypes = [], followupStatuses = []
  allCollabsList.map(collab => {
    if (collab.company && !companies.includes(collab.company))
      companies.push(collab.company)
    if (collab.statut && !statuses.includes(collab.statut))
      statuses.push(collab.statut)
    if (collab.type_collab && !collabsTypes.includes(collab.type_collab))
      collabsTypes.push(collab.type_collab)
    if (collab.silaeStatus && !silaeStatuses.includes(collab.silaeStatus))
      silaeStatuses.push(collab.silaeStatus)
  })

  allMissionsFollowups.map(f => {
    if (f.status && !followupStatuses.includes(f.status))
      followupStatuses.push(f.status)
    if (f.type && !followupTypes.includes(f.type))
      followupTypes.push(f.type)
  })

  const statusItemTemplate = (option) => {
    if (option)
      return <Tag value={<Langs str={option} />} severity={getTagClass(option)} />
    return <div><Langs str={'Select'} /></div>
  }

  const statusRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value}
        options={statuses}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={statusItemTemplate}
        valueTemplate={statusItemTemplate}
        placeholder={<Langs str={"Select"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const followupStatusRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value}
        options={followupStatuses}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={statusItemTemplate}
        valueTemplate={statusItemTemplate}
        placeholder={<Langs str={"Select"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const followupTypeRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value}
        options={followupTypes}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={statusItemTemplate}
        valueTemplate={statusItemTemplate}
        placeholder={<Langs str={"Select"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const collabsTypeRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value}
        options={collabsTypes}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={statusItemTemplate}
        valueTemplate={statusItemTemplate}
        placeholder={<Langs str={"Select"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const companiesItemTemplate = (option) => {
    if (option)
      return (
        <div className="flex align-items-center gap-2">
          <span>{option}</span>
        </div>
      )
    return <div><Langs str={'Select'} /></div>
  }

  const companyRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value}
        options={companies}
        onChange={(e) => options.filterApplyCallback(e.value)}
        itemTemplate={companiesItemTemplate}
        valueTemplate={companiesItemTemplate}
        placeholder={<Langs str={"Select"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const contractTypeRowFilterTemplate = (options) => {
    let typeOfContractStrings = [
      'CDI',
      'Indépendant',
      'Portage',
      'Contrat d\'apprentissage',
      'Sous traitant',
      'Intérimaire',
      'CDD',
      'Agence',
      'Convention de stage'
    ]
    return (
      <MultiSelect
        value={options.value || []}
        options={typeOfContractStrings}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder={<Langs str={"Select One"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const handleViewChange = (view) => {
    if (view != null) {
      let selectedTeamId = selectedTeamsIds[0]
      navigate(`/contracts/${selectedTeamId}/${view}`)
    }
  }

  const contractTypeFilterFunction = (value, filters) => {
    if (!filters || filters.length === 0) return true;
    return filters.includes(value);
  }

  const motifSortieRowFilterTemplate = (options) => {
    let typesOfMotifSortie = [
      "Démission",
      "Licenciement",
      "Rupture conventionnelle",
      "Rupture anticipée du contrat",
      "Fin de CDD",
      "Rupture de période d’essai employeur",
      "Rupture de période d’essai salarié",
      "Retraite",
      "Décès",
      "Invalidité"
    ]
    return (
      <MultiSelect
        value={options.value || []}
        options={typesOfMotifSortie}
        onChange={(e) => options.filterApplyCallback(e.value)}
        placeholder={<Langs str={"Select One"} />}
        className="p-column-filter"
        showClear
        style={{ minWidth: '12rem' }}
      />
    )
  }

  const motifSortieFilterFunction = (value, filters) => {
    if (!filters || filters.length === 0) return true;
    return filters.includes(value);
  }

  const dateFilterTemplate = (options) => {
    return <Calendar value={options.value}
      onChange={(e) => options.filterCallback(e.value, options.index)}
      dateFormat="dd/mm/yy"
      placeholder="dd/mm/yyyy"
      mask="99/99/9999" />
  }

  const typeCollabBodyTemplate = (rowData) => {
    return <Tag severity={getTagClass(rowData.type_collab)} value={Localize(rowData.type_collab)} />
  }

  const silaeStatusBodyTemplate = (silaeStatus) => {
    let background = "grey"
    let color = "white"
    let border = "none"
    switch (silaeStatus) {
      case "Closed":
        background = "red"
        break
      case "Non-Closed":
        background = "slateBlue"
        break
      case "Ongoing":
        background = "white"
        color = "black"
        border = "1px solid black"
        break
      default:
        break
    }
    return <Tag style={{ background, color, border }} value={Localize(silaeStatus)} />
  }

  const navToTeam = (rowData) => {
    const encodedLabel = encodeURIComponent(rowData.current_team_name);
    navigate(`/clients/${selectedTeamsIds[0]}/1/${encodedLabel}`);
    //setSelectedTeams([rowData.id_team])
  }

  const teamBodyTemplate = (rowData) => {
    return (
      <a className={styles.linkStyle} onClick={() => navToTeam(rowData)}>{rowData.current_team_name}</a>
    )
  }

  const rowHeaderTemplate = (data) => {
    return <React.Fragment>
      <span className="vertical-align-middle ml-2 font-bold line-height-3">
        {data.prenom} {data.nom}
      </span>
    </React.Fragment>
  }

  const rowFooterTemplate = (data) => {
    return (
      <React.Fragment>
        <td colSpan={100}>
          <div className="d-flex justify-content-start fw-bold w-100">
            <Langs str={"Total"} /> <Langs str={viewsOptions[selectedView].label} /> : {allMissionsFollowups.filter(c => c.id_collab == data.id_collab).length}
          </div>
        </td>
      </React.Fragment>
    )
  }

  function renderBody() {
    let scrollHeight = "calc(100vh - 280px)"
    switch (isMobile) {
      case 2:
        scrollHeight = "calc(100vh - 340px)"
        break;
      case 3:
        scrollHeight = "calc(100vh - 270px)"
        break;
      default:
        break;
    }

    let date = moment().format("DD-MM-YYYY")
    let subView = viewsOptions[selectedView]
    if (subView) {
      switch (subView.value) {
        case 0:
          return <div className={styles.collabsCard}>
            <DataTable ref={dtCollabs}
              exportFilename={`Collabs_export_${date}`}
              onValueChange={(data) => setFilteredContracts(data)}
              value={allCollabsList}
              dataKey="id"
              paginator
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              rowsPerPageOptions={[10, 25, 50]}
              rows={25}
              scrollable
              scrollHeight={scrollHeight}
              sortMode="single"
              filters={collabsFilters}
              currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
              onRowDoubleClick={(e) => viewCollabModal(e.data)}
              selectionMode="single"
              header={collabsTableHeader}
            >
              <Column field="nom" filter filterPlaceholder="nom" header={Localize("Family Name")} sortable dataType="text" style={{ minWidth: '9rem' }}></Column>
              <Column field="prenom" filter filterPlaceholder="prenom" header={Localize("Name")} sortable style={{ minWidth: '9rem' }}></Column>
              <Column field="company" header={Localize("Company")} sortable style={{ minWidth: '8rem' }} filterField="company" showFilterMatchModes={false} filter filterElement={companyRowFilterTemplate}></Column>
              <Column field="type_collab" header={Localize("Type")} body={typeCollabBodyTemplate} sortable style={{ minWidth: '8rem' }} showFilterMatchModes={false} filter filterElement={collabsTypeRowFilterTemplate}></Column>
              <Column field="statut" header={Localize("Status")} sortable body={statusBodyTemplate} style={{ minWidth: '7rem' }} showFilterMatchModes={false} filter filterElement={statusRowFilterTemplate}></Column>
              {/*<Column field="current_team_name" header={Localize("Team")} body={teamBodyTemplate} filter sortable style={{ minWidth: '9rem' }}></Column>*/}
              <Column field="type_contrat" header={Localize("CONTRACT_TYPE")} showFilterMatchModes={false} filter filterFunction={contractTypeFilterFunction} filterElement={contractTypeRowFilterTemplate} sortable style={{ minWidth: '10rem' }}></Column>
              {/*<Column field="current_poste" header={Localize("Poste")} filter sortable style={{ minWidth: '12rem' }}></Column>*/}
              <Column field="nature_emploi" header={Localize("Nature emploi")} filter sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="etablissement" header={Localize("Etablissement de rattachement")} filter sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="exitDate" header={Localize("Date de fin de du contrat en cours")} body={dateBodyTemplate} sortable filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="motif_sortie" header={Localize("Motif de la sortie effective")} sortable style={{ minWidth: '10rem' }} filter showFilterMatchModes={false} filterElement={motifSortieRowFilterTemplate} filterFunction={motifSortieFilterFunction}></Column>
              <Column field="date_debut_cp" header={Localize("date_debut_cp")} body={dateBodyTemplate} sortable filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="date_fin_cp" header={Localize("date_fin_cp")} body={dateBodyTemplate} sortable filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="new_date_fin_cp" header={Localize("new_date_fin_cp")} body={dateBodyTemplate} sortable filter filterElement={dateFilterTemplate} dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="tjm_achat" header={Localize("tjm_achat")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="tjm_vente" header={Localize("tjm_vente")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="subcontractor" header={Localize("Subcontractor")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="subcontractor_email" header={Localize("Subcontractor Email")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="school" header={Localize("school")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="school_contact" header={Localize("school_contact")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="diploma" header={Localize("diploma")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="tutor" header={Localize("tutor")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="training_cost" header={Localize("training_cost")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="remaining_cost" header={Localize("remaining_cost")} sortable style={{ minWidth: '8rem' }}></Column>
            </DataTable>
          </div>
        case 1:
          return <div className={styles.collabsCard}>
            <DataTable ref={dtMissions}
              onValueChange={(data) => setFilteredMissions(data)}
              exportFilename={`Missions_export_${date}`}
              value={allMissionsList}
              dataKey="id"
              paginator
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              rowsPerPageOptions={[10, 25, 50]}
              rows={25}
              scrollable
              scrollHeight={scrollHeight}
              sortMode="single"
              filters={missionsFilters}
              currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
              onRowDoubleClick={(e) => viewCollabModal(e.data)}
              selectionMode="single"
              header={missionsTableHeader}
            >
              <Column field="nom" filter filterPlaceholder="nom" header={Localize("Family Name")} sortable dataType="text" style={{ minWidth: '9rem' }}></Column>
              <Column field="prenom" filter filterPlaceholder="prenom" header={Localize("Name")} sortable style={{ minWidth: '9rem' }}></Column>
              <Column field="statut" header={Localize("Status")} sortable body={statusBodyTemplate} style={{ minWidth: '7rem' }} showFilterMatchModes={false} filter filterElement={statusRowFilterTemplate}></Column>
              <Column field="client" header={Localize("Client")} sortable style={{ minWidth: '14rem' }}></Column>
              <Column field="current_team_name" header={Localize("team_name")} body={teamBodyTemplate} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="start_date" header={Localize("start_date")} body={startDateBodyTemplate} filter filterElement={dateFilterTemplate} sortable dataType="date" style={{ minWidth: '13rem' }}></Column>
              <Column field="end_date" header={Localize("end_date")} body={endDateBodyTemplate} filter filterElement={dateFilterTemplate} sortable dataType="date" style={{ minWidth: '13rem' }}></Column>
              <Column field="current_team_location" header={Localize("location")} sortable style={{ minWidth: '8rem' }}></Column>
              <Column field="poste_name" header={Localize("poste_name")} sortable style={{ minWidth: '14rem' }}></Column>
              <Column field="group_name" header={Localize("Groupe")} sortable style={{ minWidth: '14rem' }}></Column>
              <Column field="created_at" header={Localize("created_at")} body={dateBodyTemplate} sortable dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="created_by" header={Localize("created_by")} sortable style={{ minWidth: '13rem' }}></Column>
              <Column field="updated_at" header={Localize("updated_at")} body={dateBodyTemplate} sortable dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="updated_by" header={Localize("updated_by")} sortable style={{ minWidth: '13rem' }}></Column>
            </DataTable>
          </div>
        case 2:
          return <div className={styles.collabsCard}>
            <DataTable ref={dtMissionsSuivis}
              onValueChange={(data) => setFilteredMissionsSuivis(data)}
              exportFilename={`Suivis_missions_export_${date}`}
              value={allMissionsFollowups}
              dataKey="id"
              paginator
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              rowsPerPageOptions={[10, 25, 50]}
              rows={25}
              scrollable
              scrollHeight={scrollHeight}
              sortMode="single"
              filters={missionsSuivisFilters}
              currentPageReportTemplate={`{first} ${Localize("to")} {last} ${Localize("of")} {totalRecords}`}
              onRowDoubleClick={(e) => viewReviewModal(e.data)}
              selectionMode="single"
              header={missionsSuivisTableHeader}
            >
              <Column field="prenom" header={Localize("prenom")} filter sortable style={{ minWidth: '14rem' }}></Column>
              <Column field="nom" header={Localize("nom")} filter sortable style={{ minWidth: '14rem' }}></Column>
              <Column field="status" header={Localize("Status")} sortable body={statusFollowupBodyTemplate} style={{ minWidth: '8rem' }} showFilterMatchModes={false} filter filterElement={followupStatusRowFilterTemplate}></Column>
              <Column field="client" header={Localize("Client")} filter sortable style={{ minWidth: '14rem' }}></Column>
              <Column field="current_team_name" header={Localize("Team")} body={teamBodyTemplate} filter sortable style={{ minWidth: '14rem' }}></Column>
              <Column field="week" header={Localize("Semaine")} sortable dataType="text" style={{ minWidth: '9rem' }} body={d => parseInt(d.week) + 1}></Column>
              <Column field="type" header={Localize("Suivi")} sortable body={typeFollowupBodyTemplate} style={{ minWidth: '12rem' }} showFilterMatchModes={false} filter filterElement={followupTypeRowFilterTemplate}></Column>
              <Column field="comments" header={Localize("Comments")} style={{ maxWidth: '14rem', whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}></Column>
              <Column field="created_at" header={Localize("created_at")} body={dateBodyTemplate} sortable dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="createdBy" header={Localize("Suivi par")} sortable style={{ minWidth: '13rem' }}></Column>
              <Column field="updated_at" header={Localize("updated_at")} body={dateBodyTemplate} sortable dataType="date" style={{ minWidth: '10rem' }}></Column>
              <Column field="updatedBy" header={Localize("updated_by")} sortable style={{ minWidth: '13rem' }}></Column>
            </DataTable>
          </div>
        default:
          break
      }
    }
  }

  function topMenu() {
    if (isMobile == 1) {
      return (
        <Row>
          <Col md={3}>
            <span className="headerTitle">
              {viewsOptions.find(o => o.value == selectedView)?.label}
            </span>
          </Col>
          <Col md={6}
            className="d-flex justify-content-center pe-4 align-items-center p-0 m-0">
            <ViewSelectButton
              options={viewsOptions}
              selectedView={viewsOptions.find(o => o.value == selectedView)?.value}
              onViewChange={handleViewChange}
            />
          </Col>
          <Col md={3}
            className="d-flex justify-content-end pe-4 align-items-center p-0 m-0 ms-auto">
            {selectedView == 0 && (
              <div>
                <ImageButton
                  image={exportIcon}
                  imageFocus={exportIconFocus}
                  onClick={exportExcelContracts}
                  active={true}
                  tooltip={<Langs str="Export contrats" />}
                  width={32} />
              </div>
            )}
            {selectedView == 1 && (
              <div>
                <ImageButton
                  image={exportIcon}
                  imageFocus={exportIconFocus}
                  onClick={exportExcelMissions}
                  active={true}
                  tooltip={<Langs str="Export missions" />}
                  width={32} />
              </div>
            )}
            {selectedView == 2 && (
              <div>
                <ImageButton
                  image={exportIcon}
                  imageFocus={exportIconFocus}
                  onClick={exportExcelSuivisMissions}
                  active={true}
                  tooltip={<Langs str="Export suivis missions" />}
                  width={32} />
              </div>
            )}
          </Col>
        </Row>
      )
    }
    if (isMobile == 2 || isMobile == 3) {
      return (
        <Row>
          <Col md={5}>
            <span className="headerTitle">
              {viewsOptions.find(o => o.value == selectedView)?.label}
            </span>
          </Col>
          <Col md={7}
            className="d-flex justify-content-between align-items-center p-0 m-0 mt-3">
            <ViewSelectButton
              options={viewsOptions}
              selectedView={viewsOptions.find(o => o.value == selectedView)?.value}
              onViewChange={handleViewChange}
            />
            {selectedView == 0 && (
              <div>
                <ImageButton
                  image={exportIcon}
                  imageFocus={exportIconFocus}
                  onClick={exportExcelContracts}
                  active={true}
                  tooltip={<Langs str="Export contrats" />}
                  width={32} />
              </div>
            )}
            {selectedView == 1 && (
              <div>
                <ImageButton
                  image={exportIcon}
                  imageFocus={exportIconFocus}
                  onClick={exportExcelMissions}
                  active={true}
                  tooltip={<Langs str="Export missions" />}
                  width={32} />
              </div>
            )}
            {selectedView == 2 && (
              <div>
                <ImageButton
                  image={exportIcon}
                  imageFocus={exportIconFocus}
                  onClick={exportExcelSuivisMissions}
                  active={true}
                  tooltip={<Langs str="Export suivis missions" />}
                  width={32} />
              </div>
            )}
          </Col>
        </Row>
      )
    }
  }

  return (
    <div className={styles.containerView}>
      <div className="topMenu">
        {topMenu()}
      </div>
      {renderBody()}
      <CollabModalDetails
        page="collabs"
        tabs={["contrat", "societe", "mission", "donneesPerso", "profil"]}
      />
      <WeeklyFollowupModal selected={selectedFollowup} onHide={() => setSelectedFollowup(null)} />
    </div>
  )
}